import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-date-range-filter',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTooltipModule,
  ],
  templateUrl: './date-range-filter.component.html',
  styleUrls: ['./date-range-filter.component.scss'],
})
export class DateRangeFilterComponent {
  startDate: Date | null = null;
  endDate: Date | null = null;
  sk = '';
  limit = 50;
  @Output() apply = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<void>();

  get startDateIso(): string {
    if (!this.startDate) return '';
    const d =
      this.startDate instanceof Date
        ? this.startDate
        : new Date(this.startDate);
    if (isNaN(d.getTime())) return '';
    return new Date(
      Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0)
    ).toISOString();
  }

  get endDateIso(): string {
    if (!this.endDate) return '';
    const d =
      this.endDate instanceof Date ? this.endDate : new Date(this.endDate);
    if (isNaN(d.getTime())) return '';
    return new Date(
      Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999)
    ).toISOString();
  }

  selectWeek(weeksAgo: number): void {
    const end = new Date();
    const day = end.getUTCDay();
    const daysSinceMonday = (day + 6) % 7;
    const endUtc = new Date(
      Date.UTC(
        end.getUTCFullYear(),
        end.getUTCMonth(),
        end.getUTCDate() - daysSinceMonday - 1 - weeksAgo * 7,
        23,
        59,
        59,
        999
      )
    );
    const startUtc = new Date(
      Date.UTC(
        endUtc.getUTCFullYear(),
        endUtc.getUTCMonth(),
        endUtc.getUTCDate() - 6,
        0,
        0,
        0,
        0
      )
    );
    this.startDate = new Date(
      startUtc.getUTCFullYear(),
      startUtc.getUTCMonth(),
      startUtc.getUTCDate()
    );
    this.endDate = new Date(
      endUtc.getUTCFullYear(),
      endUtc.getUTCMonth(),
      endUtc.getUTCDate()
    );
  }

  onClear(): void {
    this.startDate = null;
    this.endDate = null;
    this.sk = '';
    this.limit = 50;
    this.clear.emit();
  }
}
